<template>
    <div>
        <autoDesktop v-if="isDesktop()"></autoDesktop>
        <autoMobile  v-if="isMobile()"></autoMobile>
    </div>
</template>

<script>
    import autoMobile from "../parcours_dedie_sunu/auto.mobile.vue"
    import autoDesktop from "../parcours_dedie_sunu/auto.desktop.vue"

    export default {
        name: 'AutoIndex',
        components: {
            autoMobile,
            autoDesktop
        },
        data() {
            return {
                
            }
        },

        methods: {
            isMobile: function () {
                if (screen.width <= 760) {
                    return true
                } else {
                    return false
                }
            },
  
            isDesktop: function () {
                if (screen.width > 768) {
                    return true
                } else {
                    return false
                }
            },
        },
    }
</script>